import { CustomerTypeEnum } from 'common/enums/CustomerTypeEnum'

export const isCustomerCompany = (customer?: CustomerTypeEnum) =>
  customer === CustomerTypeEnum.Company

export const isCustomerPersonal = (customer?: CustomerTypeEnum) =>
  customer === CustomerTypeEnum.Personal
